import { query } from '@/services/graphql';
import * as operations from './operations';

export default {
  getCourseUnitList(variables = {}) {
    return query(operations.COURSE_UNIT_LIST, variables, true);
  },
  getCourseModulelList(variables = {}) {
    return query(operations.COURSE_MODULE_LIST, variables, false, { showErrorMessage: false });
  },
  getWordUnitList(variables = {}) {
    return query(operations.WORD_UNIT_LIST, variables, true);
  },
  getWrongBookList(variables = {}) {
    return query(operations.WRONG_BOOK_LIST, variables, true);
  },
  getCourseInfo(variables = {}) {
    return query(operations.COURSE_INFO, variables, false);
  },
  getIatUrl(variables = {}) {
    return query(operations.IAT_URL, variables, true);
  },
};
